// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { default as Avatar } from "./avatar";
export type { AvatarProps } from "./avatar";

export { default as LoadingBar } from "./loading-bar";
export type { LoadingBarProps } from "./loading-bar";

export { default as ChatBubble } from "./chat-bubble";
export type { ChatBubbleProps } from "./chat-bubble";

export { default as SupportPromptGroup } from "./support-prompt-group";
export type { SupportPromptGroupProps } from "./support-prompt-group";
